var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"row subtitle-editor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"col\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"time\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"time1 wrap\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 5, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div type=\"button\" class=\"now\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 7, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M128,73.6C98,73.6,73.6,98,73.6,128S98,182.4,128,182.4s54.4-24.4,54.4-54.4S158,73.6,128,73.6z M128,176\t\t\t\t\t\t\tc-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48S154.5,176,128,176z M128,128h26v13h-39v-6.6V128V96h13V128z M217,27H39\t\t\t\t\t\t\tc-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M128,192c-35.3,0-64-28.7-64-64\t\t\t\t\t\t\tc0-35.3,28.7-64,64-64s64,28.7,64,64C192,163.3,163.3,192,128,192z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 12, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<input type=\"text\" placeholder=\"hh:mm:ss.ff\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"rocker\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"up\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, jade_debug[0].filename ));
buf.push(" ");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 16, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M128,128l-54,54l-27-27l81-81l81,81l-27,27L128,128z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 18, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"down\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 18, jade_debug[0].filename ));
buf.push(" ");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 19, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 20, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M128,128l54-54l27,27l-81,81l-81-81l27-27L128,128z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 21, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"old-time1\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 22, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"time2 wrap\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 23, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div type=\"button\" class=\"now\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 24, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 25, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M128,73.6C98,73.6,73.6,98,73.6,128S98,182.4,128,182.4s54.4-24.4,54.4-54.4S158,73.6,128,73.6z M128,176\t\t\t\t\t\t\tc-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48S154.5,176,128,176z M128,128h26v13h-39v-6.6V128V96h13V128z M217,27H39\t\t\t\t\t\t\tc-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M128,192c-35.3,0-64-28.7-64-64\t\t\t\t\t\t\tc0-35.3,28.7-64,64-64s64,28.7,64,64C192,163.3,163.3,192,128,192z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 29, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<input type=\"text\" placeholder=\"hh:mm:ss.ff\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 30, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"rocker\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 31, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"up\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 31, jade_debug[0].filename ));
buf.push(" ");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 32, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 33, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M128,128l-54,54l-27-27l81-81l81,81l-27,27L128,128z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 34, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"down\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 34, jade_debug[0].filename ));
buf.push(" ");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 35, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 36, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M128,128l54-54l27,27l-81,81l-81-81l27-27L128,128z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 37, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"old-time2\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 38, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"durationTime\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 39, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"name\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 39, jade_debug[0].filename ));
buf.push("Dur :&nbsp;");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 40, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"duration-value\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 40, jade_debug[0].filename ));
buf.push("00.00");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 42, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"text\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 43, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"wrap\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 44, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<textarea id=\"editor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</textarea>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 45, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div title=\"Italic\" type=\"button\" class=\"italic\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 46, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 47, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M232,216H24v-16h208V216z M248,232H8v16h240V232z M147.1,162.1c1.2,1.2,0.6,5.7-1.4,6.9c-10.3-0.4-20.3-0.6-29.2-0.6\t\t\t\t\t\t\t  c-9.7,0-18.5,0.2-28.2,0.6c-1.9-1.2-1.8-6.3,1.4-6.9l5.3-1c8.4-1.6,9.9-2.8,15.6-21.2l22.8-73.7c4.9-16.1,5.1-19.4-4.9-21.2l-5.5-1\t\t\t\t\t\t\t  c-1.4-1.2-1.2-5.9,1.4-6.9c10.9,0.4,20.6,0.6,30,0.6c9,0,17.7-0.2,27.5-0.6c1.9,1.2,1.6,6.1-1,6.9l-5.6,1\t\t\t\t\t\t\t  c-8.4,1.4-9.9,2.8-15.6,21.2l-22.8,73.7c-5.1,16.1-5.1,19.4,4.9,21.2L147.1,162.1z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 52, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div title=\"BOX (Pac/Avid only)\" type=\"button\" class=\"background\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 53, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 54, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M134.6,127c1.3,4.3,0.5,5-3.3,5h-15.6c-4.2,0-5-0.7-3.5-5.2l4.2-12.7c2.5-7.7,5.8-16.6,7.2-20.5c1.5,3.5,4.5,12.5,6.8,19.6\t\t\t\t\t\t  L134.6,127z M229,39v178c0,6.6-5.4,12-12,12H39c-6.6,0-12-5.4-12-12V39c0-6.6,5.4-12,12-12h178C223.6,27,229,32.4,229,39z\t\t\t\t\t\t  M186.5,172.7l-6.3-1c-6.2-1-7.7-4.8-11.1-14.8l-22.6-65.2c-4.2-11.8-6.2-18-7.5-22.8c-0.7-2.5-1.7-3.3-3.8-3.3\t\t\t\t\t\t  c-0.3,0-6.5,8.2-14.5,10c0.5,4.8-2.3,10.6-6.2,21.1l-15.1,40.6c-4.5,12-7.7,20-10.5,26.6c-2.8,6.5-6.2,7.8-10.2,8.3l-4.5,0.5\t\t\t\t\t\t  c-1.2,1.3-1.3,4.8,0.5,5.8c7.7,0,11.5-0.5,17.1-0.5c7,0.2,13,0.2,18.8,0.5c1.7-0.8,1.3-4.7,0.3-5.8l-5-0.8c-4.7-0.8-6.8-1.9-6.8-2.9\t\t\t\t\t\t  c0-1.3,0.2-2.7,1.2-6l6.5-19.4c1-3.2,1.5-3.5,5.5-3.5h19.8c5.8,0,7.2,0.5,8,3.2l4.5,14.5c2,6.2,3.2,10.2,3.2,11.3\t\t\t\t\t\t  c0,1-0.7,2.2-4.5,2.8l-5.3,0.8c-1.8,1.3-1.5,4.8,0.3,5.8c7.7-0.3,14.1-0.5,22.5-0.5c8.7,0,17.6,0.2,25.6,0.5\t\t\t\t\t\t  C187.8,177.5,187.5,173.5,186.5,172.7z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 62, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"textlenghtL1\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 63, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"name\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 63, jade_debug[0].filename ));
buf.push("L1 :&nbsp;");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 64, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"text-valueL1\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 64, jade_debug[0].filename ));
buf.push("0");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 65, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"textlenghtL2\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 66, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"name\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 66, jade_debug[0].filename ));
buf.push("L2 :&nbsp;");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 67, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div class=\"text-valueL2\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 67, jade_debug[0].filename ));
buf.push("0\t\t");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 71, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<button title=\"Cancel\" type=\"button\" class=\"close\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 71, jade_debug[0].filename ));
buf.push("Cancel");
jade_debug.shift();
jade_debug.shift();
buf.push("</button>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 72, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<button title=\"Accept\" type=\"button\" class=\"check\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 72, jade_debug[0].filename ));
buf.push("Save");
jade_debug.shift();
jade_debug.shift();
buf.push("</button>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 74, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<div title=\"Watch Title\" type=\"button\" class=\"play\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 75, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<svg viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 76, "C:\\Dev\\repos\\player\\app\\templates\\subtitle-editor.jade" ));
buf.push("<path d=\"M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M89,63  \t\t\t\t\t\tl79.1,44L89,150V63z M191,174H65v-8h126V174z M207,198H49v-8h158V198z\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</path>");
jade_debug.shift();
jade_debug.shift();
buf.push("</svg>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".row.subtitle-editor\r\n\t.col\r\n\t\t.time\r\n\t\t\t.time1.wrap\r\n\t\t\t\tdiv.now(type=\"button\")\r\n\t\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M128,73.6C98,73.6,73.6,98,73.6,128S98,182.4,128,182.4s54.4-24.4,54.4-54.4S158,73.6,128,73.6z M128,176\\\r\n\t\t\t\t\t\t\tc-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48S154.5,176,128,176z M128,128h26v13h-39v-6.6V128V96h13V128z M217,27H39\\\r\n\t\t\t\t\t\t\tc-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M128,192c-35.3,0-64-28.7-64-64\\\r\n\t\t\t\t\t\t\tc0-35.3,28.7-64,64-64s64,28.7,64,64C192,163.3,163.3,192,128,192z')\r\n\r\n\t\t\t\tinput(type=\"text\", placeholder=\"hh:mm:ss.ff\")\r\n\t\t\t\t.rocker\r\n\t\t\t\t\t.up \r\n\t\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M128,128l-54,54l-27-27l81-81l81,81l-27,27L128,128z')\r\n\r\n\t\t\t\t\t.down \r\n\t\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M128,128l54-54l27,27l-81,81l-81-81l27-27L128,128z')\r\n\t\t\t\t.old-time1\r\n\t\t\t.time2.wrap\r\n\t\t\t\tdiv.now(type=\"button\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M128,73.6C98,73.6,73.6,98,73.6,128S98,182.4,128,182.4s54.4-24.4,54.4-54.4S158,73.6,128,73.6z M128,176\\\r\n\t\t\t\t\t\t\tc-26.5,0-48-21.5-48-48s21.5-48,48-48s48,21.5,48,48S154.5,176,128,176z M128,128h26v13h-39v-6.6V128V96h13V128z M217,27H39\\\r\n\t\t\t\t\t\t\tc-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M128,192c-35.3,0-64-28.7-64-64\\\r\n\t\t\t\t\t\t\tc0-35.3,28.7-64,64-64s64,28.7,64,64C192,163.3,163.3,192,128,192z')\r\n\t\t\t\tinput(type=\"text\", placeholder=\"hh:mm:ss.ff\")\r\n\t\t\t\t.rocker\r\n\t\t\t\t\t.up \r\n\t\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M128,128l-54,54l-27-27l81-81l81,81l-27,27L128,128z')\r\n\t\t\t\t\t.down \r\n\t\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M128,128l54-54l27,27l-81,81l-81-81l27-27L128,128z')\r\n\t\t\t\t.old-time2\r\n\t\t\t.durationTime\r\n\t\t\t\t\t.name Dur :&nbsp;\r\n\t\t\t\t\t.duration-value 00.00\r\n\r\n\t\t.text\r\n\t\t\t.wrap\r\n\t\t\t\ttextarea#editor\r\n\t\t\t\tdiv.italic(title=\"Italic\", type=\"button\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M232,216H24v-16h208V216z M248,232H8v16h240V232z M147.1,162.1c1.2,1.2,0.6,5.7-1.4,6.9c-10.3-0.4-20.3-0.6-29.2-0.6\\\r\n\t\t\t\t\t\t\t  c-9.7,0-18.5,0.2-28.2,0.6c-1.9-1.2-1.8-6.3,1.4-6.9l5.3-1c8.4-1.6,9.9-2.8,15.6-21.2l22.8-73.7c4.9-16.1,5.1-19.4-4.9-21.2l-5.5-1\\\r\n\t\t\t\t\t\t\t  c-1.4-1.2-1.2-5.9,1.4-6.9c10.9,0.4,20.6,0.6,30,0.6c9,0,17.7-0.2,27.5-0.6c1.9,1.2,1.6,6.1-1,6.9l-5.6,1\\\r\n\t\t\t\t\t\t\t  c-8.4,1.4-9.9,2.8-15.6,21.2l-22.8,73.7c-5.1,16.1-5.1,19.4,4.9,21.2L147.1,162.1z')\r\n\r\n\t\t\t\t.background(title=\"BOX (Pac/Avid only)\", type=\"button\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\t\tpath(d='M134.6,127c1.3,4.3,0.5,5-3.3,5h-15.6c-4.2,0-5-0.7-3.5-5.2l4.2-12.7c2.5-7.7,5.8-16.6,7.2-20.5c1.5,3.5,4.5,12.5,6.8,19.6\\\r\n\t\t\t\t\t\t  L134.6,127z M229,39v178c0,6.6-5.4,12-12,12H39c-6.6,0-12-5.4-12-12V39c0-6.6,5.4-12,12-12h178C223.6,27,229,32.4,229,39z\\\r\n\t\t\t\t\t\t  M186.5,172.7l-6.3-1c-6.2-1-7.7-4.8-11.1-14.8l-22.6-65.2c-4.2-11.8-6.2-18-7.5-22.8c-0.7-2.5-1.7-3.3-3.8-3.3\\\r\n\t\t\t\t\t\t  c-0.3,0-6.5,8.2-14.5,10c0.5,4.8-2.3,10.6-6.2,21.1l-15.1,40.6c-4.5,12-7.7,20-10.5,26.6c-2.8,6.5-6.2,7.8-10.2,8.3l-4.5,0.5\\\r\n\t\t\t\t\t\t  c-1.2,1.3-1.3,4.8,0.5,5.8c7.7,0,11.5-0.5,17.1-0.5c7,0.2,13,0.2,18.8,0.5c1.7-0.8,1.3-4.7,0.3-5.8l-5-0.8c-4.7-0.8-6.8-1.9-6.8-2.9\\\r\n\t\t\t\t\t\t  c0-1.3,0.2-2.7,1.2-6l6.5-19.4c1-3.2,1.5-3.5,5.5-3.5h19.8c5.8,0,7.2,0.5,8,3.2l4.5,14.5c2,6.2,3.2,10.2,3.2,11.3\\\r\n\t\t\t\t\t\t  c0,1-0.7,2.2-4.5,2.8l-5.3,0.8c-1.8,1.3-1.5,4.8,0.3,5.8c7.7-0.3,14.1-0.5,22.5-0.5c8.7,0,17.6,0.2,25.6,0.5\\\r\n\t\t\t\t\t\t  C187.8,177.5,187.5,173.5,186.5,172.7z')\r\n\t\t\t\tdiv.textlenghtL1\r\n\t\t\t\t\t.name L1 :&nbsp;\r\n\t\t\t\t\t.text-valueL1 0\r\n\t\t\t\tdiv.textlenghtL2\r\n\t\t\t\t\t.name L2 :&nbsp;\r\n\t\t\t\t\t.text-valueL2 0\t\t\r\n\r\n\r\n\r\n\t\t\t\tbutton.close(title=\"Cancel\", type=\"button\") Cancel\r\n\t\t\t\tbutton.check(title=\"Accept\", type=\"button\") Save\r\n\t\t\t\t\t\r\n\t\t\t\tdiv.play(title=\"Watch Title\", type=\"button\")\r\n\t\t\t\t\tsvg(viewBox=\"0 0 256 256\" style=\"enable-background:new 0 0 256 256\" xml:space=\"preserve\" fill=\"currentColor\")\r\n\t\t\t\t\t\tpath(d='M217,27H39c-6.6,0-12,5.4-12,12v178c0,6.6,5.4,12,12,12h178c6.6,0,12-5.4,12-12V39C229,32.4,223.6,27,217,27z M89,63\\\r\n  \t\t\t\t\t\tl79.1,44L89,150V63z M191,174H65v-8h126V174z M207,198H49v-8h158V198z')");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/subtitle-editor.jade
// module id = 422
// module chunks = 0